<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary"
                        (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ getText(processConfig?.globalizationConfig, 'title') | uppercase }}
            </ion-label>
        </ion-item>

        <app-step-description
                [description]="getText( processConfig?.globalizationConfig, 'instructions' )"
        ></app-step-description>

        <ion-grid class="validation">
            <ion-row>
                <ion-col size-md="6" size-sm="12" size-xs="12">
                    <app-360-evaluation-users-list
                        #userList
                        [users]="users"
                        (selectUser)="selectUser($event)"
                        (reopenUser)="reopenUser()"
                    ></app-360-evaluation-users-list>
                </ion-col>
                <ion-col size-md="6" size-sm="12" size-xs="12">
                    <app-360-evaluation-empty-state
                            *ngIf="!selectedUser"
                    ></app-360-evaluation-empty-state>

          <app-360-evaluation-user-evaluators
            *ngIf="selectedUser"
            [userSelected]="selectedUser"
            [areas]="areas"
            [processConfig]="processConfig"
            (wasApproved)="resetSelection()"
          ></app-360-evaluation-user-evaluators>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>